<template>
  <div class="product-card h-100" @click="selectProduct">
    <div class="card border-0 shadow-sm h-100 product-card-inner">
      <!-- Product Badge -->
      <div v-if="product.badge" class="product-badge position-absolute">
        <span class="badge bg-gold text-white px-2 py-1 rounded-pill">
          {{ product.badge }}
        </span>
      </div>
      
      <!-- Product Image -->
      <div class="card-img-top product-image-container">
        <ImageWrapper 
          :src="product.image" 
          :alt="product.name"
          class="product-image img-fluid"
        />
      </div>
      
      <!-- Product Info -->
      <div class="card-body d-flex flex-column">
        <h5 class="card-title product-name mb-2">{{ product.name }}</h5>
        
        <div class="product-price mt-auto">
          <span class="current-price fw-bold text-dark">{{ product.price }}</span>
          <span v-if="product.originalPrice" class="original-price text-muted txt-delete ms-2">
            {{ product.originalPrice }}
          </span>
        </div>
        
        <!-- Quick Action Buttons -->
        <div class="product-actions mt-3">
          <button 
            class="btn btn-outline-primary btn-sm w-100"
            @click.stop="addToCart"
          >
            {{ $t('common.addToCart') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ImageWrapper } from '~/components/'

export default {
  name: 'ProductCard',
  
  components: {
    ImageWrapper
  },
  
  props: {
    product: {
      type: Object,
      required: true,
      validator(value) {
        return value && value.id && value.name && value.price && value.image
      }
    }
  },
  
  methods: {
    /**
     * Handles product selection
     */
    selectProduct() {
      this.$emit('select', this.product)
    },
    
    /**
     * Handles add to cart action
     */
    addToCart() {
      this.$emit('add-to-cart', this.product)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~/scss/include/_commonInclude.scss";

.content .app {
  .product-card {
    cursor: pointer;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    
    &:hover {
      transform: translateY(-5px);
      
      .product-card-inner {
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15) !important;
      }
    }
    
    .product-card-inner {
      border-radius: rem(12);
      overflow: hidden;
      transition: box-shadow 0.3s ease;
      
      .product-badge {
        top: rem(12);
        right: rem(12);
        z-index: 2;
        
        .badge {
          font-size: rem(10);
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
      }
      
      .product-image-container {
        position: relative;
        padding: rem(24);
        background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
        text-align: center;
        
        .product-image {
          max-height: rem(200);
          width: auto;
          transition: transform 0.3s ease;
        }
      }
      
      .card-body {
        padding: rem(20);
        
        .product-name {
          font-size: rem(16);
          font-weight: 600;
          color: color(black);
          line-height: 1.3;
          margin-bottom: rem(8);
        }
        
        .product-price {
          .current-price {
            font-size: rem(18);
            color: color(gold);
          }
          
          .original-price {
            font-size: rem(14);
          }
        }
        
        .product-actions {
          .btn {
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            border-radius: rem(6);
            font-size: rem(12);
            padding: rem(8) rem(16);
            border-color: color(gold);
            color: color(gold);
            
            &:hover {
              background-color: color(gold);
              border-color: color(gold);
              color: color(whiteAbs);
            }
          }
        }
      }
    }
    
    // Responsive adjustments
    @include media-breakpoint-down(sm) {
      .product-card-inner {
        .product-image-container {
          padding: rem(16);
          
          .product-image {
            max-height: rem(150);
          }
        }
        
        .card-body {
          padding: rem(16);
          
          .product-name {
            font-size: rem(14);
          }
          
          .product-price {
            .current-price {
              font-size: rem(16);
            }
          }
        }
      }
    }
  }
}
</style>